




import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconPreview extends Vue {
    @Prop({ type: Number, default: 48 }) readonly size!: number
}
